/**
 * Public landing contact form — posts to /api/contact (Resend on the backend).
 */
export async function submitContactMessage({ name, email, message }) {
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  const url = `${baseUrl}/api/contact`;

  let response;

  try {
    response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ name, email, message }),
    });
  } catch (err) {
    throw new Error(err?.message || 'Could not reach the server');
  }

  let body;

  try {
    body = await response.json();
  } catch {
    throw new Error(`Contact endpoint returned non-JSON (HTTP ${response.status})`);
  }

  if (!response.ok || !body?.success) {
    throw new Error(body?.error || 'Could not send message. Please try again.');
  }

  return body;
}
